<template>
  <el-form
    ref="uploadDocuments"
    :model="uploadDocumentsForm"
    :rules="uploadDocumentsForm.rules"
  >
    <el-row
      class="select-category"
    >
      <el-form-item
        prop="category"
      >
        <el-select
          v-model="uploadDocumentsForm.category"
          placeholder="Select"
        >
          <el-option
            v-for="(category, index) in categories"
            :label="category.name"
            :value="category.value"
            :key="index"
          />
        </el-select>
      </el-form-item>
    </el-row>
    <div
      v-if="uploadDocumentsForm.category"
    >
      <el-row
        type="flex"
        justify="center"
      >
        <el-form-item
          prop="fileList"
        >
          <el-upload
            accept=".jpeg,.jpg,.pdf,.doc"
            action="#"
            :auto-upload="false"
            drag
            :file-list="uploadDocumentsForm.fileList"
            multiple
            :limit="countFiles"
            :on-exceed="onExceed"
            :on-change="onChange"
            :on-remove="onRemove"
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">
              Drop files here or <em>click to upload</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-row>
      <el-row
        type="flex"
        justify="center"
      >
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('uploadDocuments')"
          >
            Upload
          </el-button>
        </el-form-item>
      </el-row>
    </div>
    <el-row
      v-else
      type="flex"
      justify="center"
    >
      <p>
        Select category to upload files
      </p>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'UploadDocuments',
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function () {
    return {
      categories: [],
      uploadDocumentsForm: {
        category: '',
        fileList: [],
        rules: {
          category: [
            { required: true, message: 'Document category is required' }
          ],
          fileList: [
            { required: true, message: 'At least one file should be uploaded', trigger: 'change' }
          ]
        }
      },
      countFiles: 0
    };
  },
  created () {
    this.countDocumentsUpload();
    this.getCategories();
  },
  methods: {
    getCategories () {
      this.$axios('/Patient/GetCategoriesForFibroidDocumentsReview', {
        method: 'GET',
        params: {
          patientNumber: this.user.patientNumber,
          token: this.$route.params.token
        }
      }).then((response) => {
        this.categories = response.data.data;
      }).catch((error) => {
        this.$message.error(error.response.data.errorMessage);
      });
    },
    countDocumentsUpload () {
      this.$axios('/Patient/GetCountNewDocumentsAllowedToUpload', {
        method: 'GET',
        params: {
          patientNumber: this.user.patientNumber
        }
      }).then((response) => {
        this.countFiles = response.data.data;
      });
    },
    onExceed () {
      this.$message.warning(`You can't upload more than ${this.countFiles} files`);
    },
    onChange (file) {
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);

        reader.onload = function () {
          resolve(reader.result);
        };
      }).then((base64) => {
        file.base64 = base64.split(';base64,')[1];
        this.uploadDocumentsForm.fileList.push(file);
      });
    },
    onRemove (file) {
      this.uploadDocumentsForm.fileList.splice(this.uploadDocumentsForm.fileList.findIndex(item => item.uid === file.uid), 1);
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadFiles();
        } else {
          return false;
        }
      });
    },
    uploadFiles () {
      this.$emit('screenLoading', true);
      let data = [];
      this.uploadDocumentsForm.fileList.map((file) => {
        data.push({
          patientNumber: this.user.patientNumber,
          blobData: file.base64,
          currentDateTime: new Date(),
          extension: file.name.split('.').pop(),
          name: file.name.split('.')[0]
        });
      });
      this.$axios('/Patient/StoreDocumentFibroidReviewDocuments', {
        method: 'PUT',
        data: data,
        params: {
          token: this.$route.params.token,
          categoryCode: this.uploadDocumentsForm.category
        }
      }).then(() => {
        this.$emit('screenLoading', false);
        this.$message.success('Documents has been saved');
      }).catch((error) => {
        this.$emit('screenLoading', false);
        this.$message.error(error.response.data.errorMessage);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.select-category {
  display: flex;
  justify-content: center;

  .el-select {
    width: 300px;
  }
}
</style>
